"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalConfirm = exports.confirm = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var ModalMain_1 = require("./ModalMain");
var button_1 = require("../button");
var ModalMessage_1 = require("./ModalMessage");
var i18n_1 = require("../i18n");
var configprovider_1 = require("../configprovider");
var noop_1 = require("../_util/noop");
/**
 * API 的方式唤起一个确认对话框
 * @param options
 * @returns 异步返回布尔值，为 true 则表示用户确认，为 false 则表示用户取消
 */
function confirm(options) {
    var _this = this;
    var _a = options.onOk, onOk = _a === void 0 ? noop_1.noop : _a, _b = options.onCancel, onCancel = _b === void 0 ? noop_1.noop : _b, restOptions = tslib_1.__rest(options, ["onOk", "onCancel"]);
    return new Promise(function (resolve) {
        var el = document.createElement("div");
        react_dom_1.default.render(react_1.default.createElement(configprovider_1.ConfigProvider, null,
            react_1.default.createElement(ModalConfirmAPI, tslib_1.__assign({}, restOptions, { onOk: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, onOk()];
                            case 1:
                                _a.sent();
                                resolve(true);
                                return [2 /*return*/];
                        }
                    });
                }); }, onCancel: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, onCancel()];
                            case 1:
                                _a.sent();
                                resolve(false);
                                return [2 /*return*/];
                        }
                    });
                }); }, onExited: function () {
                    react_dom_1.default.unmountComponentAtNode(el);
                } }))), el);
    });
}
exports.confirm = confirm;
function ModalConfirmAPI(_a) {
    var _this = this;
    var onOk = _a.onOk, onCancel = _a.onCancel, confirmModalProps = tslib_1.__rest(_a, ["onOk", "onCancel"]);
    var _b = tslib_1.__read(react_1.useState(false), 2), visible = _b[0], setVisible = _b[1];
    // 渲染之后，马上显示
    react_1.useEffect(function () { return setVisible(true); }, []);
    var ok = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onOk()];
                case 1:
                    _a.sent();
                    setVisible(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var cancel = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onCancel()];
                case 1:
                    _a.sent();
                    setVisible(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(ModalConfirm, tslib_1.__assign({ visible: visible, onOk: ok, onCancel: cancel, onClose: cancel }, confirmModalProps)));
}
/**
 * 提供原始的 ModalConfirm 组件。
 * 推荐使用 `Modal.confirm()` API 来简化用法
 */
function ModalConfirm(_a) {
    var message = _a.message, description = _a.description, icon = _a.icon, modalProps = tslib_1.__rest(_a, ["message", "description", "icon"]);
    react_1.useEffect(function () {
        window.focus();
    }, []);
    return (react_1.default.createElement(ModalMain_1.Modal, tslib_1.__assign({ disableEscape: true }, modalProps),
        react_1.default.createElement(ModalMain_1.Modal.Body, null,
            react_1.default.createElement(ModalMessage_1.ModalMessage, { icon: icon, message: message, description: description })),
        react_1.default.createElement(ModalMain_1.Modal.Footer, null,
            react_1.default.createElement(ModalButton, tslib_1.__assign({}, modalProps)))));
}
exports.ModalConfirm = ModalConfirm;
function ModalButton(_a) {
    var _this = this;
    var onOk = _a.onOk, okText = _a.okText, onCancel = _a.onCancel, cancelText = _a.cancelText;
    var t = i18n_1.useTranslation();
    var mainButtonRef = react_1.useRef(null);
    var _b = tslib_1.__read(react_1.useState(false), 2), okLoading = _b[0], setOkLoading = _b[1];
    var _c = tslib_1.__read(react_1.useState(false), 2), cancelLoading = _c[0], setCancelLoading = _c[1];
    react_1.useEffect(function () {
        if (mainButtonRef.current) {
            mainButtonRef.current.focus();
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(button_1.Button, { type: "primary", htmlType: "button", loading: okLoading, disabled: cancelLoading, onClick: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setOkLoading(true);
                            return [4 /*yield*/, onOk()];
                        case 1:
                            _a.sent();
                            setOkLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); }, ref: mainButtonRef }, okText || t.okText),
        react_1.default.createElement(button_1.Button, { htmlType: "button", loading: cancelLoading, disabled: okLoading, onClick: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setCancelLoading(true);
                            return [4 /*yield*/, onCancel()];
                        case 1:
                            _a.sent();
                            setCancelLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); } }, cancelText || t.cancelText)));
}
//# sourceMappingURL=ModalConfirm.js.map